export default __webpack_public_path__ + "static/media/logo.60cd9484.webp";